const initialState = {
    // Step 1 — Select Part
    selected_part: null,

    // Step 2 — Select Classes
    selected_classes: [],

    // Step 3 — Tags & Names
    // { "Smudge": ["Smudge1", "Smudge2"], "Scratch": ["scratch1"] }
    additional_defect_tags: {},
};

/**
 * importFromDatasetFormDataReducer: Accumulates form data across all 3 steps
 * of the "Import from Dataset" flow.
 *
 * Used on final submit to build the createDefectFromPartAPI payload:
 * {
 *   part_id:               formData.selected_part._id,
 *   usecase_id:            formData.selected_part.usecase_id,
 *   claases_to_extract:    formData.selected_classes,
 *   additional_defect_tags: formData.additional_defect_tags,
 * }
 */
const importFromDatasetFormDataReducer = (state = initialState, action: any) => {
    switch (action.type) {

        // Merge partial updates (generic)
        case "SET_IMPORT_FROM_DATASET_FORM_DATA":
            return { ...state, ...action?.payload };

        // Step 1
        case "SET_IMPORT_FROM_DATASET_SELECTED_PART":
            return { ...state, selected_part: action?.payload };

        // Step 2
        case "SET_IMPORT_FROM_DATASET_SELECTED_CLASSES":
            return { ...state, selected_classes: action?.payload };

        // Step 3
        case "SET_IMPORT_FROM_DATASET_DEFECT_TAGS":
            return { ...state, additional_defect_tags: action?.payload };

        // Reset on modal close / after submit
        case "RESET_IMPORT_FROM_DATASET_FORM_DATA":
            return initialState;

        default:
            return state;
    }
};

export default importFromDatasetFormDataReducer;